import SigamAPI from '~/utils/SigamAPI';

export default async function Update({ institutionId, data }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/settings`,
    method: 'POST',
    data: { ...data },
  });

  return response;
}
